import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";

const ACK_KEY = "c2g_prohibited_ack";
export const hasProhibitedAck = () => localStorage.getItem(ACK_KEY) === "1";

// Confirmation « marchandises interdites » avant d'utiliser l'adresse Colis2Go
export const ProhibitedNotice = ({ value, onChange }) => {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(null);
  useEffect(() => {
    if (open && !text) api.get("/content/prohibited").then(({ data }) => setText(data)).catch(() => {});
  }, [open, text]);
  return (
    <div className="mt-3 text-sm">
      <label className="flex items-start gap-2 cursor-pointer">
        <Checkbox data-testid="prohibited-ack" checked={value} onCheckedChange={(v) => {
          onChange(!!v);
          if (v) localStorage.setItem(ACK_KEY, "1"); else localStorage.removeItem(ACK_KEY);
        }} />
        <span>
          {t("proh.ack")}{" "}
          <button type="button" data-testid="prohibited-link" className="underline text-accent font-semibold" onClick={() => setOpen(true)}>
            {t("proh.link")}
          </button>
        </span>
      </label>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="prohibited-dialog" className="max-h-[85vh] overflow-y-auto">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><ShieldAlert className="h-5 w-5 text-accent" /> {t("proh.title")}</DialogTitle></DialogHeader>
          <p className="text-sm whitespace-pre-line">{text ? (lang === "en" ? text.text_en : text.text_fr) : "…"}</p>
        </DialogContent>
      </Dialog>
    </div>
  );
};

// Éditeur Super Admin (liste modifiable sans code)
export const ProhibitedEditor = () => {
  const [f, setF] = useState({ text_fr: "", text_en: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/content/prohibited").then(({ data }) => setF(data)).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/content/prohibited", f); toast.success("Liste des marchandises interdites enregistrée"); }
    catch (e) { toast.error(e.response?.data?.detail || "Réservé au Super Admin"); }
    setBusy(false);
  };
  return (
    <div className="mt-8 border border-border bg-card p-5 max-w-3xl" data-testid="prohibited-editor">
      <h3 className="font-heading font-bold flex items-center gap-2"><ShieldAlert className="h-4 w-4 text-accent" /> Marchandises interdites / soumises à conditions</h3>
      <p className="text-xs text-muted-foreground mt-1">Affiché au client avant l'utilisation de l'adresse Colis2Go. Modifiable sans code (Super Admin).</p>
      <div className="mt-3 grid gap-3">
        <div><Label>Texte FR</Label><Textarea data-testid="prohibited-fr" className="rounded-sm min-h-28" value={f.text_fr} onChange={(e) => setF({ ...f, text_fr: e.target.value })} /></div>
        <div><Label>Texte EN</Label><Textarea data-testid="prohibited-en" className="rounded-sm min-h-28" value={f.text_en} onChange={(e) => setF({ ...f, text_en: e.target.value })} /></div>
      </div>
      <Button data-testid="prohibited-save" disabled={busy} className="mt-3 rounded-sm bg-accent text-white" onClick={save}>Enregistrer</Button>
    </div>
  );
};
